// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0759b9fb","455":"baecd2d3","828":"38929ab9"}[chunkId] + ".chunk.js";
};